import React from 'react';
import { useTranslation } from 'react-i18next';
import './FounderSection.css';

const FounderSection = () => {
  const { t } = useTranslation();
  const founderImage = `${process.env.PUBLIC_URL || ''}/images/founder.png`;
  return (
    <section className="founder-section section-padding">
      <div className="container">
        <h2 className="founder-title fade-up stagger-1">{t('founder_section_title')}</h2>
        <div className="founder-content-grid">
          <div className="founder-image-container fade-up">
            <img
              src={founderImage}
              alt="Uday Karjigimath, Founder"
              className="founder-image"
            />
          </div>
        </div>
        <div className="founder-text-content">
          <h3 className="founder-name fade-up stagger-2">{t('founder_section_name')}</h3>
          <div className="founder-bio fade-up stagger-3">
            <p>{t('founder_section_bio_p1')}</p>
            <p>{t('founder_section_bio_p2')}</p>
            <p>{t('founder_section_bio_p3')}</p>
            <p>{t('founder_section_bio_p4')}</p>
            <p>{t('founder_section_bio_p5')}</p>
            <p>{t('founder_section_bio_p6')}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FounderSection;
